import React, { type ReactElement } from 'react';
import { Box, Button } from '@saviynt/design-system';

import { useInvertedLocalize } from '../../../../../shared/hooks';
import ViolationsTabDetailsActions from '../ViolationsTabDetailsActions';

import './ViolationsTabDetailsFooter.css';

/**
 * ViolationsTabDetailsFooter component renders the footer section of the Violations Tab Details panel.
 * It provides navigation controls and action buttons for violations management.
 *
 * The footer includes:
 * - A back button that returns to the previous screen or violations home based on source
 * - Conditional action buttons for mitigating and remediating violations
 * - A more options menu button
 */

interface ViolationsTabDetailsFooterProps {
  handleBackButton: () => void;
}

/**
 * Renders footer actions for violations details
 */
function ViolationsTabDetailsFooter({
  handleBackButton,
}: ViolationsTabDetailsFooterProps): ReactElement {
  const l = useInvertedLocalize();

  return (
    <>
      <Button kind='subtle' onClick={handleBackButton}>
        {l('Back')}
      </Button>
      <Box className='Sod-ViolationsTabDetailsFooter-actions'>
        <ViolationsTabDetailsActions />
      </Box>
    </>
  );
}

export default ViolationsTabDetailsFooter;
